module.exports = __webpack_public_path__ + "static/media/so-algo--goose2.1d99327c.jpg";